export default __webpack_public_path__ + "static/media/hotel1.bff0c3d4.jpg";